(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fes-bracelet-purchase"] && !Shopify.designMode) return;
  try {
    function refineBraceletPurchase() {
    document.querySelectorAll('.fes-bracelet-purchase').forEach(root => {
      if (root.dataset.fesRefined) return;
      const dataElement = document.getElementById('fes-bracelet-options-' + root.dataset.sectionId);
      if (!dataElement) return;
      const data = JSON.parse(dataElement.textContent);
      root.dataset.fesRefined = 'true';
      let pendingStyle = null;
      root.addEventListener('click', event => {
        const tier = event.target.closest('.bndlr-radio-container');
        if (tier && tier.dataset.bundlerBreakActive !== 'true') {
          pendingStyle = root.querySelector('variant-selects select')?.value || null;
        }
      }, true);
      const updateLabels = () => {
        const pickers = root.querySelectorAll('.bndlr-radio-container[data-bundler-break-active="true"] .bndlr-option-select[name="option0"]');
        if (pendingStyle && pickers.length) {
          const style = pendingStyle;
          pendingStyle = null;
          if (data.variants.some(variant => variant.option1 === style && variant.available)) {
            pickers.forEach(select => {
              if (select.value !== style) {
                select.value = style;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          }
        }
        root.querySelectorAll('.bndlr-variant-label').forEach(label => {
          if (label.textContent.trim() === 'Color') label.textContent = data.style;
        });
        root.querySelectorAll('.bndlr-option-select[name="option0"] option').forEach(option => {
          const variant = data.variants.find(item => item.option1 === option.value);
          if (!variant) return;
          const label = option.value + (variant.available ? '' : ' — ' + data.soldOut);
          if (option.textContent !== label) option.textContent = label;
          option.disabled = !variant.available;
        });
      };
      updateLabels();
      new MutationObserver(updateLabels).observe(root, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refineBraceletPurchase, { once: true });
  } else {
    refineBraceletPurchase();
  }
  document.addEventListener('shopify:section:load', refineBraceletPurchase);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fes-cart-layout"] && !Shopify.designMode) return;
  try {
    function placeCartRecommendations() {
    const footer = document.querySelector('#main-cart-footer');
    const section = footer?.closest('.shopify-section');
    if (!section) return;
    document.querySelectorAll('.cbb-also-bought-container').forEach(widget => {
      if (widget.previousElementSibling !== section) section.after(widget);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeCartRecommendations);
  else placeCartRecommendations();
  new MutationObserver(placeCartRecommendations).observe(document.documentElement, {childList: true, subtree: true});
  } catch(e) { console.error(e); }
})();

})();
